export default "__VITE_ASSET__DSiidAZh__"